import { BareFeedTemplate } from '@go-shared/types/feedTemplate';
import { RequestMethod, apiGet, apiPost, apiRequest } from '.';

export async function getFeedTemplatesByProperty(propertyId: string): Promise<BareFeedTemplate[]> {
  return apiGet(`/property/${propertyId}/feed-templates`);
}

export async function uploadPageBackgroundImage(file: File): Promise<string> {
  const fd = new FormData();
  fd.append('file', file);

  return apiRequest(RequestMethod.Post, '/feed-blueprint/page-background-image', true, null, fd, {
    'Content-Type': 'multipart/form-data',
  });
}

export async function saveFeedTemplate(
  feedTemplate: BareFeedTemplate,
  shouldCascadeUpdate: boolean
): Promise<BareFeedTemplate> {
  return apiPost('/feed-blueprint/save', { feedTemplate, shouldCascadeUpdate });
}

export async function updateSailingDayFeed(body: {
  sailingId: string;
  sailingDayId: string;
  feedTemplateId: string;
}): Promise<void> {
  await apiPost('/feed-blueprint/update-sailing-day-feed', body);
}

export async function getFonts(): Promise<string[]> {
  return apiGet('/feed-blueprint/fonts');
}

export async function uploadFont(file: File): Promise<void> {
  const fd = new FormData();
  fd.append('file', file);

  return apiRequest(RequestMethod.Post, '/feed-blueprint/upload-font', true, null, fd, {
    'Content-Type': 'multipart/form-data',
  });
}
